<div class="chat-button-position">
    <nb-badge *ngIf="newMessage > 0" [text]="newMessage" status="success" position="top right"></nb-badge>
    <button nbButton shape="round" size="large" status="primary" class="chat-button" (click)="startChat($event)">
        <nb-icon icon="message-circle-outline"></nb-icon>
    </button>
</div>